import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt } from '@fortawesome/pro-solid-svg-icons';

class OverrideControls extends React.Component {
  static propTypes = {
    overridden: PropTypes.bool,
    onOverrideDefault: PropTypes.func.isRequired,
    onUseDefault: PropTypes.func.isRequired
  }

  state = {
    hovering: false
  }

  handleClick = () => {
    if (this.props.overridden) {
      this.props.onUseDefault();
    } else {
      this.props.onOverrideDefault();
    }
  }

  handleMouseEnter = () => {
    this.setState({ hovering: true });
  }

  handleMouseLeave = () => {
    this.setState({ hovering: false });
  }

  render() {
    const { hovering } = this.state;
    const label = this.props.overridden ? 'Use Default' : 'Click to Override';

    return (
      <a
        className={classNames('email-option-override-controls', { hovering })}
        onClick={this.handleClick}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        {hovering ? label : null}
        <FontAwesomeIcon className="icon" icon={faPencilAlt} />
      </a>
    );
  }
}

export default OverrideControls;
